import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/infrastructure/api/client";
import { ApiError, type BookletResponseDto } from "@tabipla/shared";

export function useBooklet(shareCode: string | undefined) {
  return useQuery({
    queryKey: ["booklet", shareCode],
    queryFn: async () => {
      if (!shareCode) {
        throw new Error("Share code is required");
      }
      const response = await apiClient.get<BookletResponseDto>(`/api/booklet/${shareCode}`);
      if (!response.success || !response.data) {
        throw ApiError.fromResponse(response.error, "Booklet not found");
      }
      return response.data;
    },
    enabled: !!shareCode,
  });
}
